const jsonFetch = async (url, { headers, body, ...options } = {}) => {
  const token = document.querySelector('meta[name="csrf-token"]').content

  options = {
    headers: new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": token,
      ...headers,
    }),
    credentials: "same-origin",
    body: body && JSON.stringify(body),
    ...options
  }

  const response = await fetch(url, options)

  if (!response.ok) return Promise.reject(response)
  if (response.status == 204) return response

  return response.json()
};

export { jsonFetch }
